import React, { Component } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  width: 70px;
  height: 70px;
  background-image: ${props => props.image ? 'url(' + props.image + ')' : ''};
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-right: 10px;
  cursor: pointer;
`

class Cup extends Component {
  constructor(props) {
    super(props)
  }

  onClick = () => {
    this.props.onChange(this.props.number)
  }

  getImage = (estado) => {
    if (estado === 'empty') {
      return (
        '/assets/empty.svg'
      )
    }
    else if (estado === 'half') {
      return (
        '/assets/half.svg'
      )
    } else {
      return (
        '/assets/full.svg'
      )
    }
  }

  render() {
    return (
      <Container image={this.getImage(this.props.estado)} onClick={this.onClick} >
        <span
          style={this.props.estado === 'empty' ? { color: '#CCCCCC', fontSize: '24px' } : { color: '#FFFFFF', fontSize: '24px' }}
        >
          {this.props.estado === 'half' ? (this.props.number) + '.5' : this.props.number + 1}
        </span>
      </Container>
    )
  }
}

export default Cup



// WEBPACK FOOTER //
// ./src/Components/CustomButtons/Cup.jsx